import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RichText } from "@/components/RichText";

export const TxtField = ({ label, value, onChange, testid }) => (
  <div className="space-y-1">
    <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
    <Input aria-label={label} data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} className="h-10" />
  </div>
);

export const TxtArea = ({ label, value, onChange, testid }) => (
  <div className="space-y-1">
    <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
    <Textarea aria-label={label} data-testid={testid} value={value || ""} onChange={(e) => onChange(e.target.value)} rows={2} />
  </div>
);

export const RichField = ({ label, value, onChange, testid, mode = "default", minHeight, placeholder }) => (
  <div className="space-y-1">
    <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
    <RichText
      value={value}
      onChange={onChange}
      testid={testid}
      mode={mode}
      minHeight={minHeight}
      placeholder={placeholder}
      ariaLabel={label}
    />
  </div>
);

export const NumField = ({ label, value, onChange, testid }) => (
  <div className="space-y-1">
    <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
    <Input aria-label={label} data-testid={testid} type="number" value={value ?? 0} onChange={(e) => onChange(parseFloat(e.target.value) || 0)} className="h-10" />
  </div>
);

export const SelectField = ({ label, value, onChange, options, testid, ariaLabel }) => (
  <div className="space-y-1">
    <Label className="text-xs uppercase tracking-wider text-muted-foreground">{label}</Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger aria-label={ariaLabel || label} data-testid={testid} className="h-10"><SelectValue /></SelectTrigger>
      <SelectContent>{options.map((o) => (<SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>))}</SelectContent>
    </Select>
  </div>
);
